import * as React from "react";
import {
  Button,
  Slider,
  TextField,
  Typography,
  useTheme,
  Popper,
  Paper,
  Box,
  ClickAwayListener,
} from "@mui/material";
import { StaticTimePicker } from "@mui/x-date-pickers";
import { format, isPast, isValid } from "date-fns";

import { AppContext } from "../../contextProviders/AppContext";
import { translation } from "../Dictionary";
import { useContext } from "react";

export default function TimePickerComponent({
  title,
  onChange,
  hasError,
  onChangeSlider,
  timeValue,
  sliderValue,
  endTimeOk,
  selectedDateRange,
  selectedPicker,
  setSelectedPicker,
  type,
  contentHeigth,
  FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA,
}) {
  const theme = useTheme();
  const { language, locale, mobileViewPort, setInitSearch } =
    useContext(AppContext);

  const advanceFunction = () => {
    if (type === "startTime") {
      return setSelectedPicker("returnTime");
    }
    if (type === "returnTime") {
      setSelectedPicker(null);
      setInitSearch(true);
    }
  };

  const [anchorPopper, setAnchorPopper] = React.useState(null);

  /*   const focusTimeField = (event) => {
    setOpen(type);
    setAnchorPopper(event.currentTarget);
  }; */

  const ref = React.useRef(null);
  React.useEffect(() => {
    setAnchorPopper(ref.current);
  }, []);

  const [timePickerView, setTimePickerView] = React.useState(true);
  const [hideSlider, setHideSlider] = React.useState(false);
  const handleTimePickerView = () => {
    setTimePickerView((prevState) => !prevState);
    setHideSlider((prevState) => !prevState);
  };
  const RangeShortcutsPanel = ({ children, handleTimePickerView }) => {
    const customProps = {
      ...children,
      props: {
        ...children.props,

        toggleMobileKeyboardView: () => handleTimePickerView(),
      },
    };
    return <React.Fragment>{customProps}</React.Fragment>;
  };

  const TimeErrorMessage = () => {
    if (isValid(selectedDateRange[0]) && isValid(selectedDateRange[1])) {
      if (selectedDateRange[0] > selectedDateRange[1] && type === "startTime") {
        return translation.get(language, "Time error message start time");
      }
      if (
        selectedDateRange[0] > selectedDateRange[1] &&
        type === "returnTime"
      ) {
        return translation.get(language, "Time error message start time");
      }
      if (selectedDateRange[0].getTime() === selectedDateRange[1].getTime()) {
        return "Varauksen kesto on 0 tuntia";
      }
    }
  };

  return (
    <Box
      ref={ref}
      sx={{
        display: "flex",
        borderRadius: "10px",
        bgcolor: selectedPicker === type ? "white" : "transparent",
        boxShadow: selectedPicker === type ? theme.shadows[2] : "transparent",
        height: contentHeigth,
        justifyContent: "center",
        alignItems: "center",
        transition: "ease-in-out 250ms",
        alignItems: "center",
        justifyContent: "center",
        borderStyle: "solid",
        borderWidth: 2,
        cursor: "pointer",
        "&:hover": {
          bgcolor: "rgba(0,0,0,0.05)",
          boxShadow: theme.shadows[2],
        },
        borderColor:
          endTimeOk.errorComponent === type ||
          (hasError && selectedPicker === type)
            ? theme.palette.warning.main
            : "transparent",
      }}
      // onClick={() => setSelectedPicker(type)}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={() =>
          FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA
            ? null
            : setSelectedPicker(type)
        }
      >
        <Typography
          color={theme.palette.primary.mainText}
          sx={{ wordWrap: "break-word", textAlign: "center" }}
        >
          {endTimeOk.errorComponent === type && endTimeOk.hasError
            ? translation.get(language, "Timepicker closed error")
            : hasError
            ? translation.get(language, "Check times label")
            : title}
        </Typography>
        <Typography color={theme.palette.primary.mainText}>
          {" "}
          {isValid(timeValue)
            ? format(new Date(timeValue), "HH:mm", {
                locale: locale,
              })
            : ""}
        </Typography>
      </Box>
      <Popper
        id={"textIdPopper"}
        open={selectedPicker === type}
        anchorEl={anchorPopper}
        placement="bottom"
        sx={{
          width: mobileViewPort ? "95vw" : "350px",
          offset: "25px",
          zIndex: 1000,
        }}
      >
        <ClickAwayListener onClickAway={() => setSelectedPicker(null)}>
          <Paper
            elevation={3}
            sx={{
              borderRadius: "20px",
              width: "320px",
              marginTop: "12px",
              paddingTop: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                maxWidth: "inherit",
              }}
            >
              <Box>
                <StaticTimePicker
                  ampm={false}
                  isMobileKeyboardViewOpen={timePickerView}
                  toolbarTitle={
                    <Box
                      sx={{
                        maxWidth: "250px",
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "16px" }}
                        color={theme.palette.primary.mainText}
                      >
                        {title}
                      </Typography>
                    </Box>
                  }
                  value={timeValue}
                  onChange={onChange}
                  components={{ PaperContent: RangeShortcutsPanel }}
                  componentsProps={{
                    paperContent: { handleTimePickerView },

                    actionBar: {
                      actions: [],
                    },
                  }}
                  renderInput={(params) => <></>}
                  sx={{
                    padding: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",

                    "& .MuiPickersToolbar-content": {
                      maxWidth: "250px",
                    },
                  }}
                />
                {!hideSlider && (
                  <Box
                    sx={{
                      zIndex: 99999,
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                    display="flex"
                  >
                    <Slider
                      color="secondary"
                      valueLabelDisplay="off"
                      value={sliderValue}
                      step={1}
                      max={47}
                      onChange={onChangeSlider}
                    />
                  </Box>
                )}
              </Box>
            </Box>
            <Box>
              <Typography
                align="center"
                sx={{
                  color:
                    endTimeOk.hasError || hasError
                      ? theme.palette.warning.main
                      : theme.palette.primary.mainText,
                  marginTop: "7px",
                }}
              >
                {endTimeOk.hasError && endTimeOk.errorComponent === type ? (
                  endTimeOk.message
                ) : hasError ? (
                  <span>{TimeErrorMessage()}</span>
                ) : null}
              </Typography>
            </Box>
            <AdvanceButton
              type={type}
              endTimeOk={endTimeOk}
              hasError={hasError}
              onClick={advanceFunction}
            />
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
}

function AdvanceButton({ type, onClick, endTimeOk, hasError }) {
  const theme = useTheme();
  const { language } = React.useContext(AppContext);
  const buttonText =
    type === "startTime"
      ? translation.get(language, "Next label")
      : type === "returnTime"
      ? translation.get(language, "Search label")
      : "";

  const buttonColor = React.useMemo(() => {
    if (type === "starTime") {
      return "primary";
    }
    if (type === "returnTime") {
      return "success";
    }
  }, [type, endTimeOk, hasError]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        paddingBottom: "7px",
        marginTop: "15px",
      }}
    >
      <Button
        onClick={onClick}
        variant="contained"
        color={buttonColor}
        disabled={endTimeOk.hasError || hasError}
        sx={{
          marginRight: "5px",
          height: "40px",
          borderBottomRightRadius: "20px",
          borderTopRightRadius: "20px",
          // borderRadius: "20px",
          width: "95px",
        }}
      >
        <Typography variant="body2" color={theme.palette.primary.buttonText}>
          {buttonText}
        </Typography>
      </Button>
    </Box>
  );
}

function TimePickerInput({ pickerProps }) {
  const pickerinPropsit = {
    ...pickerProps,
    inputProps: {
      ...pickerProps.inputProps,

      placeholder: "päivämäärä",
    },
  };

  return (
    <TextField
      InputProps={{ disableUnderline: true }}
      variant="standard"
      {...pickerinPropsit}
    ></TextField>
  );
}
